import { FormattedDate } from "@dgs/core";
import { parseISO } from "date-fns";
import { FC } from "react";
import styled from "styled-components";
import { ListItemSubtitle } from "../../../shared/ui/list/listComponents";

const StyledListItemSubtitle = styled(ListItemSubtitle)`
	gap: ${({ theme }) => theme.spacing(1)};
	display: flex;
`;

export const DurationSubtitle: FC<{ duration: { start: string; end: string } }> = ({ duration: { start, end } }) => {
	if (start === end) {
		return <FormattedDate as={ListItemSubtitle} date={parseISO(start)} format={{ dateStyle: "medium" }} />;
	}
	return (
		<StyledListItemSubtitle>
			<FormattedDate as="span" date={parseISO(start)} format={{ dateStyle: "medium" }} />
			-
			<FormattedDate as="span" date={parseISO(end)} format={{ dateStyle: "medium" }} />
		</StyledListItemSubtitle>
	);
};
